import React from "react";

interface Lead {
  id: string;
  first_name: string;
  email: string;
  phone_number: string;
}

interface LeadsTableProps {
  leads: Lead[];
  onLeadClick?: (lead: Lead) => void;
}

const LeadsTable: React.FC<LeadsTableProps> = ({ leads, onLeadClick }) => {
  const getLeadId = (lead: any) => lead.id ?? lead.lead_id ?? "N/A";
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Lead id</th>
          <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>First name</th>
          <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Email</th>
          <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Phone number</th>
        </tr>
      </thead>
      <tbody>
        {(!leads || leads.length === 0) ? (
          <tr>
            <td colSpan={4} style={{ textAlign: 'center', padding: '8px' }}>No leads available</td>
          </tr>
        ) : (
          leads.map((lead) => (
            <tr key={getLeadId(lead)} onClick={() => onLeadClick && onLeadClick(lead)} style={{ cursor: onLeadClick ? 'pointer' : 'default' }}>
              <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{getLeadId(lead)}</td>
              <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{lead.first_name}</td>
              <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{lead.email}</td>
              <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{lead.phone_number}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};

export default LeadsTable;